import type { ColumnInfo } from '@townsquare/columns/types';

export function getPeopleColumnsToFetchInTql(columns: ColumnInfo[]) {
	return {
		includeManagerData: columns.some((column) => column.id === 'managerData') || false,
		includeTeams: columns.some((column) => column.id === 'userTeams') || false,
	};
}
